import { useState } from "react";
import { CheckIcon, LinkIcon } from "@heroicons/react/24/outline";
import { IconButton } from "../ui";
import { buildDocumentLink } from "../../util/documentLink";
import { copyTextToClipboard } from "../../util/copyToClipboard";

const COPIED_FEEDBACK_MS = 2000;

const CopyDocumentLinkButton = props => {
  const { fileName } = props || {};
  const [copied, setCopied] = useState(false);

  if (!fileName) return null;

  const handleCopy = async () => {
    const link = buildDocumentLink({
      origin: window.location.origin,
      pathname: window.location.pathname,
      fileName,
    });

    const success = await copyTextToClipboard(link);
    if (!success) return;

    setCopied(true);
    window.setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
  };

  return (
    <IconButton
      variant="clean"
      title={copied ? "Link copied" : "Copy link to document"}
      onClick={handleCopy}
    >
      {copied ? (
        <CheckIcon className="h-4 w-4 cursor-pointer text-green-500" />
      ) : (
        <LinkIcon className="h-4 w-4 cursor-pointer text-gray-400" />
      )}
    </IconButton>
  );
};

export default CopyDocumentLinkButton;
